import React from "react";
/* Small inputs shared by the Budget & Cash and Sales Team screens.
   Settings writes sync to the cloud, so text and number fields commit on
   blur / Enter — one store (and network) write per edit, not per keystroke. */

function NumInput({ value, onCommit, min = 0, step = 1, width = 90, suffix, prefix, placeholder, label }: any) {
  const [draft, setDraft] = React.useState<any>(value == null ? "" : String(value));
  React.useEffect(() => { setDraft(value == null ? "" : String(value)); }, [value]);
  const commit = () => { const n = parseFloat(draft); onCommit(isFinite(n) ? Math.max(min, n) : null); };
  return (
    <span className="rep-spend" style={{ flexShrink: 0 }}>
      {prefix && <span>{prefix}</span>}
      <input className="tnum" type="number" min={min} step={step} style={{ width }} value={draft} placeholder={placeholder || "0"} aria-label={label}
        onChange={e => setDraft(e.target.value)} onBlur={commit}
        onKeyDown={e => { if (e.key === "Enter") (e.target as HTMLInputElement).blur(); }} />
      {suffix && <span>{suffix}</span>}
    </span>
  );
}

function TextField({ value, onCommit, placeholder, style, label }: any) {
  const [draft, setDraft] = React.useState<any>(value || "");
  React.useEffect(() => { setDraft(value || ""); }, [value]);
  return (
    <input className="input" value={draft} placeholder={placeholder} aria-label={label || placeholder} style={style}
      onChange={e => setDraft(e.target.value)}
      onBlur={() => { if ((draft || "").trim() !== (value || "")) onCommit((draft || "").trim()); }}
      onKeyDown={e => { if (e.key === "Enter") (e.target as HTMLInputElement).blur(); }} />
  );
}

/* segmented toggle — [{ id, label, title? }] */
function Seg({ options, value, onChange, label }: any) {
  return (
    <div className="seg wrap" role="group" aria-label={label}>
      {options.map((o: any) => (
        <button key={o.id} type="button" className={"seg-btn" + (value === o.id ? " on" : "")} aria-pressed={value === o.id}
          title={o.title} style={{ padding: "6px 11px", fontSize: 12.5 }} onClick={() => onChange(o.id)}>{o.label}</button>
      ))}
    </div>
  );
}

export { NumInput, TextField, Seg };
